import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChromePicker } from 'react-color';
import { LazyIcon } from 'components/SettingsSidebar/views/AreaIcons/iconLibraries';
import { Trash3 } from 'react-bootstrap-icons';
import { IconButton } from 'components/Buttons';
import cx from 'classnames';

export default function IconRenderer({
    areaIcons,
    onRemoveIcon,
    iconColor,
    iconSize = 16,
    handleIconColorChange,
    showColorPicker,
    setShowColorPicker,
    isInsideTileRow = false,
    showIconNames = false,
    wrapperClassName,
}) {
    const { t } = useTranslation('documents');
    const [selectedIconIndex, setSelectedIconIndex] = useState(0);

    return (
        <>
            {areaIcons?.map((areaIcon, index) => {
                const { icon } = areaIcon;

                return (
                    <div className={cx('flex-center', wrapperClassName)} key={`icon-${icon}-${index}`}>
                        <div
                            className="flex-center"
                            onClick={() => {
                                setSelectedIconIndex(index);
                            }}
                        >
                            <LazyIcon
                                name={icon}
                                className={!isInsideTileRow ? 'cursor-pointer' : undefined}
                                color={areaIcon.color || iconColor}
                                size={iconSize}
                                onClick={() => {
                                    if (setShowColorPicker) {
                                        setShowColorPicker(!showColorPicker);
                                    }
                                }}
                            />
                            {showIconNames && <div className="ml-2">{icon}</div>}
                            {showColorPicker && selectedIconIndex === index && (
                                <div className="position-absolute" style={{ right: '1.5rem' }}>
                                    <ChromePicker
                                        color={areaIcon.color || iconColor}
                                        onChange={(color) => handleIconColorChange(color, index)}
                                        disableAlpha={true}
                                    />
                                </div>
                            )}
                        </div>

                        {!isInsideTileRow && (
                            <IconButton
                                className="flex-shrink-0 ml-2"
                                onClick={() => onRemoveIcon(index)}
                                tooltip={t('global:btn.delete')}
                                icon={<Trash3 className="text-danger" size={14} />}
                            />
                        )}
                    </div>
                );
            })}
        </>
    );
}
